import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'

import context from '../core/context'

function DeveloperStep({ labels, dark }) {
  const { fetching, developers, filterDevelopers, selectedDevelopers, toggleDeveloper, setStep } =
    useContext(context)

  useEffect(() => {
    filterDevelopers()
  }, [])

  function nextStep() {
    setStep(2)
    document.dispatchEvent(new CustomEvent('step-updated'))
  }

  const prevStep = () => {
    setStep(0)
    document.dispatchEvent(new CustomEvent('step-updated'))
  }

  function isSelected(devId) {
    return selectedDevelopers.includes(devId)
  }

  if (fetching) {
    return (
      <div className="developer-search__view">
        <div className="developer-search__header">
          {labels.headline && (
            <h2
              className={`headline headline--hero ${dark ? 'text-white' : 'text-deep-blue'}`}
              dangerouslySetInnerHTML={{ __html: labels.headline }}
            />
          )}
          <div className="developer-search__view__header" />
        </div>
        <div className="developer-search__loading">...Loading</div>
      </div>
    )
  }

  return (
    <div className="developer-search__view">
      <div className="developer-search__header">
        {labels.headline && (
          <h2
            className={`headline headline--hero ${dark ? 'text-white' : 'text-deep-blue'}`}
            dangerouslySetInnerHTML={{ __html: labels.headline }}
          />
        )}
        <div className="developer-search__view__header">
          {developers.length > 0 && labels.step_2.headline && (
            <h3 className={`headline headline--md ${dark ? 'text-white' : 'text-deep-blue'}`}>
              {labels.step_2.headline}
            </h3>
          )}
          {developers.length === 0 && labels.step_2.no_items_label && (
            <h3 className={`headline headline--md ${dark ? 'text-white' : 'text-deep-blue'}`}>
              {labels.step_2.no_items_label}
            </h3>
          )}
        </div>
      </div>
      <div className="developer-search__wrapper">
        {developers.length > 0 && (
          <div className="developer-search__grid">
            {developers.map(developer => (
              <div className="developer-search__grid__item" key={developer.id}>
                <button
                  type="button"
                  className={`developer-search__card${isSelected(developer.id) ? ' developer-search__card--selected' : ''}`}
                  onClick={() => {
                    toggleDeveloper(developer.id)
                  }}
                >
                  <div className="developer-search__card__inner">
                    <div className="developer-search__card__name">
                      <h3 className="headline text--xxl">{developer.name}</h3>
                    </div>
                    <div className="developer-search__card__wrapper">
                      {developer.roles.length > 0 && (
                        <div className="developer-search__card__role">
                          <span className="text text--md font-bold">{developer.roles[0].name}</span>
                        </div>
                      )}
                      {developer.skills.length > 0 && (
                        <div className="developer-search__card__wrapper">
                          <h4 className="headline text--md align-left">Top Skills:</h4>
                          <div className="developer-search__card__skills">
                            {developer.skills.slice(0, 3).map(skill => (
                              <span
                                className="developer-search__card__skill"
                                key={`skill-${skill.term_id}`}
                              >
                                {skill.name}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="developer-search__card__meta">
                      <p className="text text--sm">
                        <strong>Years of experience:</strong> {developer.years_of_experience} year
                        {`${Number(developer.years_of_experience) > 1 ? 's' : ''}`}
                      </p>
                      <p className="text text--sm">
                        <strong>Level of english:</strong> {developer.english_level}
                      </p>
                    </div>
                    <div className="developer-search__card__cta text text--sm" />
                  </div>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="developer-search__nav">
        <button
          className={`btn ${dark ? 'btn--green text-white' : 'btn--white text-deep-blue'}`}
          type="button"
          onClick={prevStep}
        >
          {labels.step_2.prev_step_cta_label}
        </button>
        <button
          className={`btn ${dark ? 'btn--white text-deep-blue' : 'btn--deep-blue text-white'}`}
          type="button"
          onClick={nextStep}
        >
          {labels.step_2.next_step_cta_label}
        </button>
      </div>
    </div>
  )
}

DeveloperStep.propTypes = {
  labels: PropTypes.object.isRequired,
  dark: PropTypes.bool.isRequired,
}

export default DeveloperStep
